import "./CorporateTraining.css";
import trainingImage from "../assets/training.jpeg";
import ctaImage from "../assets/training-cta.jpeg"; 
import { Helmet } from "react-helmet-async";
import { useState } from "react";

export default function Training() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="training-page">

      {/* SEO */}
      <Helmet>
        <title>Corporate Training in Kenya | Business Growth Training Nairobi</title>


<link rel="canonical" href="https://satimatechnova.co.ke/corporate-training/" />

        <meta
          name="description"
          content="Corporate training in Kenya designed to help businesses generate leads, increase sales, and improve digital marketing performance. Based in Nairobi."
        />
        <meta
          name="keywords"
          content="corporate training Kenya, business training Nairobi, digital marketing training Kenya, sales training Kenya, employee training programs Kenya, Satima Technova"
        />
        <meta name="author" content="Satima Technova" />

        {/* Open Graph */}
        <meta property="og:title" content="Corporate Training in Kenya" />
        <meta property="og:description" content="Transform your team into a revenue-generating machine with practical business training." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://satimatechnova.co.ke/corporate-training/" />

      

        {/* FAQ Schema Markup */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What does your corporate training in Kenya include?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Our corporate training in Kenya covers digital marketing training, social media management, sales conversion strategies, and content creation. The program equips your team with practical skills to generate leads, increase engagement, and drive business growth."
                }
              },
              {
                "@type": "Question",
                "name": "How long does the training take?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "The duration of our business training in Nairobi depends on your company’s needs. We offer flexible sessions ranging from one-day workshops to multi-day programs focused on implementation and results."
                }
              },
              {
                "@type": "Question",
                "name": "Do you offer training for teams in Nairobi?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, we provide corporate training for teams in Nairobi and across Kenya. Training can be conducted at your business location or at a convenient venue."
                }
              },
              {
                "@type": "Question",
                "name": "Is this training suitable for small businesses?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, our employee training programs in Kenya are suitable for both small businesses and established companies. We tailor the training to match your business goals and industry."
                }
              },
              {
                "@type": "Question",
                "name": "What results can we expect?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Your team can expect improved lead generation, better customer engagement, stronger online visibility, and higher sales conversion rates after completing the training."
                }
              },
              {
                "@type": "Question",
                "name": "How do we book the training?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "You can book the training by visiting our contact page and reaching out to discuss your needs and schedule your session."
                }
              }
            ]
          }
          `}
        </script>
      </Helmet>

  
  {/* HERO SECTION */}

<section
  className="training-hero-section"
  style={{
    backgroundImage: `url(${trainingImage})`
  }}
>

  <div className="training-hero-overlay">

    <div className="training-hero-container">

      <div className="training-hero-content">

        <p className="training-hero-badge">
          CORPORATE GROWTH TRAINING
        </p>


        <h1 className="training-hero-heading">
          Transform Your Team Into A Digital Growth Engine
        </h1>


        <p className="training-hero-paragraph">
          Practical <strong>digital marketing, social media, and sales training</strong>
          designed to help your team attract customers, generate leads, and drive growth.
        </p>


        <a
          href="https://wa.me/254775137928"
          target="_blank"
          rel="noopener noreferrer"
          className="training-hero-btn"
        >
          Book Training on WhatsApp
        </a>


        <div className="training-trust-points">

          <span>
            ✓ Practical business-focused training
          </span>

          <span>
            ✓ Digital marketing & sales skills
          </span>

          <span>
            ✓ Designed for Kenyan businesses
          </span>

        </div>


      </div>

    </div>

  </div>

</section>

      {/* RESULTS */}
      <section className="results">
        <div className="results-container">
          <h2>Results from Our Corporate Training in Kenya</h2>

          <ul className="results-list">
            <li>
              <span className="check">✔</span>
              <div className="result-text">
                <strong>Generate more leads</strong>
                <p>Learn how to attract high-quality prospects consistently through our digital marketing training Kenya and expand your pipeline.</p>
              </div>
            </li>

            <li>
              <span className="check">✔</span>
              <div className="result-text">
                <strong>Increase inquiries</strong>
                <p>Equip your team with employee training programs in Kenya to engage potential clients effectively, prompting more questions and interest.</p>
              </div>
            </li>

            <li>
              <span className="check">✔</span>
              <div className="result-text">
                <strong>Improve sales conversion</strong>
                <p>Turn leads into paying customers by mastering persuasive communication techniques included in our sales training Kenya program.</p>
              </div>
            </li>

            <li>
              <span className="check">✔</span>
              <div className="result-text">
                <strong>Build a strong online presence</strong>
                <p>Enhance your brand’s visibility and credibility across digital channels through practical business training Nairobi strategies.</p>
              </div>
            </li>
          </ul>
        </div>
      </section>

      {/* CTA */}
      <section className="training-cta-section">
        <div className="training-cta-container" style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
          <div className="training-cta-text-container" style={{ flex: 1 }}>
            <h2 className="training-cta-heading">
              Corporate Training in Kenya That Drives Real Business Growth
            </h2>
            <p className="training-cta-text">
              Don’t let potential sales slip away. Our <strong>Satima Business Growth Training Program</strong> equips your team with actionable <strong>digital marketing training Kenya</strong>, 
              social media, and <strong>sales training Kenya</strong> strategies that deliver real results. 
              Take the first step towards more leads, more inquiries, and higher conversions today!
            </p>
            <a
              href="/contact"
              className="training-cta-btn primary"
            >
              Contact Us Today
            </a>
          </div>

          <div className="training-cta-image-container" style={{ flex: 1 }}>
            <img src={ctaImage} alt="Corporate training session in Kenya" style={{ width: "100%", height: "auto", borderRadius: "8px" }} />
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="faq-section training-faq">
        <h2>Frequently Asked Questions About Corporate Training in Kenya</h2>

        {[
          {
            question: "What does your corporate training in Kenya include?",
            answer: "Our corporate training in Kenya covers digital marketing training, social media management, sales conversion strategies, and content creation. The program is designed to equip your team with practical skills to generate leads, increase engagement, and drive real business growth."
          },
          {
            question: "How long does the training take?",
            answer: "The duration of our business training in Nairobi depends on your company’s needs. We offer flexible training sessions ranging from intensive one-day workshops to multi-day programs focused on deeper implementation and results."
          },
          {
            question: "Do you offer training for teams in Nairobi?",
            answer: "Yes, we provide corporate training for teams in Nairobi and across Kenya. Our sessions can be conducted on-site at your business location or at a convenient training venue."
          },
          {
            question: "Is this training suitable for small businesses?",
            answer: "Absolutely. Our employee training programs in Kenya are designed for both small businesses and established companies. We tailor the training to match your business size, industry, and growth goals."
          },
          {
            question: "What results can we expect?",
            answer: "After completing our digital marketing training in Kenya, your team can expect improved lead generation, better customer engagement, stronger brand visibility, and higher sales conversion rates."
          },
          {
            question: "How do we book the training?",
            answer: "Booking is simple. You can visit our contact page or click the 'Contact Us' button to discuss your training needs and schedule your session."
          }
        ].map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              {faq.question}
              <span className="faq-toggle">{activeIndex === index ? "-" : "+"}</span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </section>

    </div>
  );
}